export function todayDate() {
    var now = new Date();
    return new Date(now.getFullYear(), now.getMonth(), now.getDate());
}

export const CalendarPosition = {
    Current: 0,
    Active: 0,
    Historic: 1,
    Future: 2,
};

export function getCalendarPosition(start, end, today = todayDate()) {
    if (start > today) {
        return CalendarPosition.Future;
    } else if (end == null || end >= today) {
        return CalendarPosition.Current;
    } else {
        return CalendarPosition.Historic;
    }
}
